import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FieldWrapper, FormField, FormGrid, } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
import { FieldToggleBoxHead, ToggleBox } from 'fable/toggleBox';
import { validateName } from 'utils/formValidator';
import { handleParseStringAsInt } from '../../utils/parseStringAsInt';
export function GeneralSettings({ formValues }) {
    return (_jsxs(FormGrid, { children: [_jsx(FormField, { children: _jsx(Field, { label: "Name", name: "name", required: true, component: FieldText, type: "text", placeholder: "Queue name...", validate: validateName }) }), _jsx(FormField, { children: _jsx(Field, { label: "Priority level (optional)", type: "number", parse: handleParseStringAsInt, min: "1", step: "1", name: "priority", component: FieldText, helpIcon: {
                        dark: true,
                        text: 'The priority level impacts the order in which  conversations are offered. Level 1 can be used for high-priority conversations (e.g. VIP customers).',
                    } }) }), _jsx(FormField, { children: _jsx(FieldWrapper, Object.assign({ label: "Default queue", helpIcon: {
                        dark: true,
                        text: 'Whenever you create a flow for a phone number, email address etc., this queue will be used as the default.',
                    } }, { children: _jsx(ToggleBox, { isOpen: formValues.is_default, headComponent: FieldToggleBoxHead, title: "Set as default queue for new flows", textProps: { variant: '2' }, input: {
                            id: 'is_default',
                            value: 'is_default',
                            name: 'is_default',
                        }, disabled: formValues.is_archived, helpIcon: formValues.is_archived
                            ? {
                                text: 'You cannot set an archived queue as default.',
                                dark: true,
                            }
                            : undefined }) })) })] }));
}
